import { ChannelForm } from './ChannelForm';
import { GeoFencing } from '../../../models/channel';
import { ChannelFormData } from '../../../pages/channelmanager/channels/channel-editor/ChannelFormData';

export class GeoFencingForm {
  // default to an empty array of zipcodes
  geoFencing: GeoFencing = { zipcodes: null };

  static create(parentForm: ChannelForm): GeoFencingForm {
    const form = new GeoFencingForm();
    return form;
  }

  static createFromData(parentForm: ChannelForm, data: ChannelFormData): GeoFencingForm {
    const form = new GeoFencingForm();
    form.loadData(data);
    return form;
  }

  private constructor() {}

  loadData(data: ChannelFormData) {
    const { channel } = data;
    const geoFencing = channel.metaData.geoFencing;
    if (geoFencing) {
      this.geoFencing = geoFencing;
    }
  }
}
